module.exports = __webpack_public_path__ + "img/Delete - Light Gray - Selected.ec114687.png";